<div class="sharry-range-calendar input-container">
  @if (isCalendar) {
    <div
      class="sharry-range-calendar__bordered"
      [class.sharry-range-calendar__bordered--readonly]="readOnly"
      [class.sharry-range-calendar__bordered--modal]="isInModal">
      @if (isExtendedDate) {
        <mat-form-field
          #formField
          class="no-error"
          [class.readonly]="readOnly"
          (focusin)="onFocusChange(true)"
          (focusout)="onFocusChange(false)">
          <span matPrefix>
            <sharry-icon
              registryName="calendar"
              class="svg-icon"
              [class.focused]="focused"></sharry-icon>
          </span>
          <mat-date-range-input
            [autofocus]="false"
            [formGroup]="range"
            (focusout)="onRangeChange(calendar, true)">
            <input
              matStartDate
              formControlName="start"
              placeholder="dd/mm/yyyy" />
            <input
              matEndDate
              formControlName="end"
              placeholder="dd/mm/yyyy" />
          </mat-date-range-input>
          @if (range.invalid && !range.pristine && !!range.get('start')?.value) {
            <small class="mat-mdc-form-field-error">{{ 'range-calendar.date-error' | i18next }}</small>
          }
        </mat-form-field>
      }
      @if (!isExtendedDate) {
        <mat-form-field
          #formField
          class="no-error"
          [autofocus]="false"
          [class.readonly]="readOnly"
          (focusin)="onFocusChange(true)"
          (focusout)="onFocusChange(false)">
          <span matPrefix>
            <sharry-icon
              registryName="calendar"
              class="svg-icon"
              [class.focused]="focused"></sharry-icon>
          </span>
          <input
            matInput
            placeholder="dd/mm/yyyy"
            [formControl]="singleStartControl"
            [matDatepicker]="picker"
            (focusout)="onRangeChange(calendar, false)" />
          <mat-datepicker #picker></mat-datepicker>
          @if (singleStartControl.invalid && !singleStartControl.pristine && !!singleStartControl.value) {
            <small class="mat-mdc-form-field-error">{{ 'range-calendar.date-error' | i18next }}</small>
          }
        </mat-form-field>
      }

      <mat-calendar
        #calendar
        [autofocus]="false"
        [class.mat-calendar-in-modal]="isInModal"
        [class.mat-calendar-readonly]="readOnly"
        [selected]="dateRange"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [headerComponent]="exampleHeader"
        [startAt]="startAt"
        [dateFilter]="dateFilter"
        (selectedChange)="onSelectedDateChange($event, isExtendedDate)"></mat-calendar>
    </div>
  }
  @if (isTime) {
    <div
      class="sharry-range-calendar__time"
      [class.sharry-range-calendar__time--modal]="isInModal"
      [style.margin-top]="isCalendar ? '2rem' : '0'">
      <div>
        <label for="start">{{ 'range-calendar.start' + (isExtendedTime ? '--extended' : '') | i18next }}</label>
        <mat-form-field class="no-error">
          <sharry-time-input
            #timeStart="ngModel"
            id="start"
            [disabled]="!dateRange || readOnly"
            [minTime]="minTimeStart"
            [timeOptions]="startOptions"
            [(ngModel)]="timeRange.start"
            (ngModelChange)="onTimeInputChange('start', $event)"></sharry-time-input>
          @if (timeStart.invalid) {
            <mat-error>errore</mat-error>
          }
        </mat-form-field>
      </div>
      @if (isExtendedTime) {
        <div>
          <label for="end">{{ 'range-calendar.end' | i18next }}</label>
          <mat-form-field class="no-error">
            <sharry-time-input
              #timeEnd="ngModel"
              id="end"
              [disabled]="!dateRange || readOnly"
              [minTime]="minTimeEnd"
              [timeOptions]="endOptions"
              [(ngModel)]="timeRange.end"
              (ngModelChange)="onTimeInputChange('end', $event)"></sharry-time-input>
            @if (timeEnd.invalid) {
              <mat-error>errore</mat-error>
            }
          </mat-form-field>
        </div>
      }
      <!-- <sharry-time-input [disabled]="!dateRange || readOnly"
                         [label]="'range-calendar.start'+(isExtendedTime?'--extended':'')"
                         [hasMinTime]="true"
                         [minTimeDateRangeParam]="dateRange"
                         [time]="timeRange.start"
                         (timeChange)="onTimeInputFocusOut('start', $event)"></sharry-time-input>
      <ng-container *ngIf="isExtendedTime">
        <sharry-time-input [disabled]="!dateRange || readOnly"
                           label="range-calendar.end"
                           [hasMinTime]="true"
                           [minTimeDateRangeParam]="dateRange"
                           [minTimeTimeParam]="timeRange.start"
                           [time]="timeRange.end"
                           (timeChange)="onTimeInputFocusOut('end', $event)"></sharry-time-input>
      </ng-container> -->
    </div>
  }
</div>
